import React from "react";
import Button from "../../form/Button";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const PricingPlanCard = ({
  pricingPlan = {},
  isAccountLoading,
  isAccountFullyEnabled,
}) => {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  const location = useLocation();
  const queryObject = Object.fromEntries(new URLSearchParams(location.search));

  return (
    <div className="rounded-xl border border-slate-300 py-10 px-6 bg-white space-y-4 flex flex-col items-center justify-center">
      <div className=" text-2xl xl:text-3xl 2xl:text-4xl font-bold text-deep-purple capitalize text-center">
        {pricingPlan.title}
      </div>

      {/* <div className="flex items-end justify-center gap-3">
        <div className="text-deep-purple text-3xl font-bold">
          {pricingPlan.price}
        </div>
        <div className="text-slate-600 text-lg line-through">
          {pricingPlan.originalPrice}
        </div>
      </div> */}

      <div className="text-xl text-slate-600 text-center font-medium">
        {pricingPlan.description}
      </div>

      {/* <div
        className="text-slate-600 text-lg mx-auto event-details-lists"
        dangerouslySetInnerHTML={{ __html: pricingPlan.featureHTML }}
      /> */}

      <div className="relative w-full">
        <Button
          // buttonLabel={pricingPlan.button.label}
          buttonLabel={
            isAccountLoading ? "Checking account..." : pricingPlan.button.label
          }
          buttonLabelClasses="text-white uppercase text-lg font-bold"
          buttonClasses="w-full  rounded-lg h-14"
          {...(session?.user?._id
            ? {
                buttonHasLink: isAccountFullyEnabled,
                buttonLink: `${pricingPlan.button.link}${
                  queryObject?.referral_code ? location?.search : ""
                }`,
                isDisable: isAccountLoading || !isAccountFullyEnabled,
              }
            : {
                buttonFunction: () => {
                  navigate(
                    `/login?callback=${pricingPlan.button.link}${
                      queryObject?.referral_code ? location?.search : ""
                    }`
                  );
                },
              })}
          loading={isAccountLoading}
          buttonType="button"
        />
      </div>
    </div>
  );
};

export default PricingPlanCard;
